import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import SubBlog from './pages/SubBlog';
import Cards from './pages/Cards';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/SubBlog/:id" element={<SubBlog />} />
        <Route path="/" element={<Home />} />
        <Route path="/cards" element={<Cards />} />
        <Route path="/:id" element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;
